/* clone-very.js — carousel arrows + pagination dashes for Very-style rows (no dependencies) */
(function () {
  'use strict';

  function initCarousel(c) {
    var track = c.querySelector('[data-cv-track]');
    if (!track) return;
    var prev = c.querySelector('[data-cv-prev]');
    var next = c.querySelector('[data-cv-next]');
    var scope = c.closest('[data-cv-scope]') || c.parentElement;
    var dots = scope ? scope.querySelector('[data-cv-dots]') : null;

    function pageW() { return Math.max(1, track.clientWidth); }
    function pages() { return Math.max(1, Math.ceil((track.scrollWidth - 2) / pageW())); }
    function current() { return Math.min(pages() - 1, Math.round(track.scrollLeft / pageW())); }

    function renderDots() {
      if (!dots) return;
      var n = pages();
      if (n < 2) { dots.innerHTML = ''; return; }
      var cur = current(), html = '';
      for (var i = 0; i < n; i++) {
        html += '<button type="button" class="clone-very-dot' + (i === cur ? ' is-active' : '') + '" data-page="' + i + '" aria-label="Page ' + (i + 1) + ' of ' + n + '"' + (i === cur ? ' aria-current="true"' : '') + '></button>';
      }
      dots.innerHTML = html;
    }

    function update() {
      renderDots();
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
      var overflow = track.scrollWidth > track.clientWidth + 2;
      if (prev) prev.style.visibility = overflow ? '' : 'hidden';
      if (next) next.style.visibility = overflow ? '' : 'hidden';
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -pageW(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: pageW(), behavior: 'smooth' }); });
    if (dots) dots.addEventListener('click', function (e) {
      var b = e.target.closest('[data-page]');
      if (!b) return;
      track.scrollTo({ left: parseInt(b.getAttribute('data-page'), 10) * pageW(), behavior: 'smooth' });
    });

    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 80); }, { passive: true });
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(update, 120); });
    if ('ResizeObserver' in window) { new ResizeObserver(function () { update(); }).observe(track); }
    update();
  }

  function init() {
    document.querySelectorAll('[data-cv-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-init when the theme editor re-renders a section
  document.addEventListener('shopify:section:load', function (e) {
    (e.target || document).querySelectorAll('[data-cv-carousel]').forEach(initCarousel);
  });
})();
